import React, { useEffect, useState } from 'react';
import {} from 'antd';
import cn from 'classnames';
import styles from './index.module.less'
import { IProduct } from 'base/interfaces/product';
import { IconPoints } from '@pro/common/IconPoints';
import { useTrans } from 'base/utils/i18n';


type IProps = {
    className?: string;
    points: IProduct['points'];
    hasBg?: boolean;
}

const PointsTag: React.FC<IProps> = (props) => {
    const {
        className,
        points,
        hasBg = true
    } = props
    const { t } = useTrans();


    if (!points?.showTag) {
        return <></>
    }

    return (
        <div className={cn(
            className,
            'points-wrap',
            styles['points-wrap'],
            { [styles['default-bg']]: hasBg }
        )}>
            <IconPoints className={cn('g-icon-points', styles.icon)}/>
            {t('web_product_ratio_points', {ratio: points?.ratio || 1})}
        </div>
    );
};

export default PointsTag